import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import cx from 'classnames'
import moment from 'moment'
import _ from 'lodash'

import { FilterTable } from 'gnos-tables'

import CustomDate from '../../../../../../../../../../../components/CustomDate'
import Currency from '../../../../../../../../../../../components/Currency'
import Money from '../../../../../../../../../../../components/TableCell/components/Money'
import Entity from '../../../../../../../../../../../components/TableCell/components/Entity'
import NoData from '../../../../../../../../../components/Workspace/components/NoData'
import InactivityIndicatorHeader from '../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Header'
import InactiveIndicatorCell from '../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Cell'
import FailedLoad from '../../../../../../../../../components/Workspace/components/FailedLoad'

import { LOCALE_PREFIX } from '../../constants'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Execution extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        dataLocale: PropTypes.string,
        failed: PropTypes.bool,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        loaded: PropTypes.bool,
        locale: PropTypes.string.isRequired,
        locked: PropTypes.bool,
        module: PropTypes.string.isRequired,
        negativeEventsLoadTableData: PropTypes.func.isRequired,
        negativeEventsTableChange: PropTypes.func.isRequired,
        negativeEventsLoadDistraintsHistory: PropTypes.func.isRequired,
        pagination: PropTypes.object,
        filter: PropTypes.object,
        setupDistraintsById: PropTypes.func.isRequired,
        sorted: PropTypes.array,
        tableId: PropTypes.string.isRequired,
        tableSelector: PropTypes.string.isRequired,
    }

    componentDidMount() {
        const { loaded, dataLocale, locale } = this.props

        if (!loaded || dataLocale !== locale) this.loadData()
    }

    shouldComponentUpdate(nextProps) {
        const {
            customData,
            data,
            isLoading,
            level,
            locale,
            pagination,
            sorted,
            tableId,
            failed,
            loaded,
            tableSelector,
            filter,
        } = this.props

        if (!_.isEqual(customData, nextProps.customData)) return true
        if (!_.isEqual(data, nextProps.data)) return true
        if (!_.isEqual(isLoading, nextProps.isLoading)) return true
        if (!_.isEqual(level, nextProps.level)) return true
        if (!_.isEqual(locale, nextProps.locale)) return true
        if (!_.isEqual(pagination, nextProps.pagination)) return true
        if (!_.isEqual(sorted, nextProps.sorted)) return true
        if (!_.isEqual(loaded, nextProps.loaded)) return true
        if (!_.isEqual(failed, nextProps.failed)) return true
        if (!_.isEqual(tableId, nextProps.tableId)) return true
        if (!_.isEqual(tableSelector, nextProps.tableSelector)) return true
        if (!_.isEqual(filter, nextProps.filter)) return true

        return false
    }

    componentDidUpdate(prevProps) {
        const { level, locale, dataLocale } = this.props

        if (prevProps.level !== level) this.loadData()
        if (locale !== dataLocale && dataLocale) this.loadData()
    }

    loadData = () => {
        const {
            id,
            module,
            block,
            level,
            negativeEventsLoadTableData,
            negativeEventsLoadDistraintsHistory,
            tableId,
            tableSelector,
            customData,
        } = this.props

        negativeEventsLoadDistraintsHistory(id, module, block)
        negativeEventsLoadTableData(
            tableId,
            tableSelector,
            id, // Entity ID
            module,
            block,
            level,
            customData
        )
    }

    handleTableChange = (changeData) => {
        const { negativeEventsTableChange, tableId, tableSelector, id, module, block, level, customData } = this.props

        negativeEventsTableChange(tableId, tableSelector, id, module, block, level, customData, changeData)
    }

    handleCheckDistraintsButton = () => {
        const { id, setupDistraintsById } = this.props

        setupDistraintsById(id)
    }

    renderInfoMessage = () => {
        const { customData } = this.props

        if (customData?.distraintsHistory) {
            return (
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.lastDistraintsCheck`}
                    values={{
                        date: customData?.distraintsHistory?.date
                            ? moment(customData?.distraintsHistory?.date, 'YYYY-MM-DD HH:mm:ss').format(
                                  'DD.MM.YYYY HH:mm:ss'
                              )
                            : 'N/A',
                        count: customData?.distraintsHistory?.count || 'N/A',
                        name: customData?.distraintsHistory?.name || 'N/A',
                    }}
                />
            )
        }

        return <FormattedMessage id={`${LOCALE_PREFIX}.noDistraintsHistory`} />
    }

    render() {
        const { intl, tableId, data, pagination, sorted, isLoading, failed, locked, filter } = this.props

        if (locked && !isLoading && !failed) {
            return (
                <div className={'ne-execution no-data'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.lockedTab` })} />
                </div>
            )
        }
        // Failed data load
        if (failed && !isLoading) {
            return (
                <div className={'ne-execution no-data'}>
                    <FailedLoad
                        customCallback={this.loadData}
                        customText={intl.formatMessage({ id: 'global.failedToLoadTabContent' })}
                        show={failed}
                    />
                </div>
            )
        }

        // Empty data
        if (_.isEmpty(data) && !isLoading && _.isEmpty(filter?.activeFilters)) {
            return (
                <div className={'ne-execution no-data'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.noData` })} />
                </div>
            )
        }

        return (
            <div className={'ne-execution'}>
                {!isLoading && (
                    <div className={'info-container'}>
                        {/* {this.renderInfoMessage()} */}

                        <button className={'check-distraints-btn'} onClick={() => this.handleCheckDistraintsButton()}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.checkDistraints`} />
                        </button>
                    </div>
                )}
                <div className={'table-title-container'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.unpaidDistraints`} />
                </div>
                <div className={'table-container'}>
                    <FilterTable
                        id={tableId}
                        data={data ?? []}
                        loading={isLoading}
                        columnsDefinition={[
                            {
                                id: 'activity',
                                accessor: 'inactive',
                                Header: ({ Controls }) => (
                                    <>
                                        {Controls}
                                        <InactivityIndicatorHeader />
                                    </>
                                ),
                                width: 35,
                                Cell: (value) => <InactiveIndicatorCell inactive={_.get(value, 'value', false)} />,
                                filterable: true,
                                filter: {
                                    type: 'VALUE',
                                    value: _.map(
                                        _.get(filter, 'availableParameters.activity.availableValues', []),
                                        (x) => ({
                                            value: _.get(x, 'value', null),
                                            item: _.get(x, 'title', null),
                                        })
                                    ),
                                },
                            },
                            {
                                accessor: 'mandatory',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.liableSubject` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        <Entity
                                            entity={_.get(value, 'value', null)}
                                            type={_.get(value, 'value.type', null)}
                                            inactive={_.get(value, 'value.inactive', false)}
                                            rowInactive={_.get(value, 'original.inactive', false)}
                                            value={_.get(value, 'value.name', null)}
                                            entId={_.get(value, 'value.id', null)}
                                            risk={_.get(value, 'value.indicators.risk', null)}
                                            caution={_.get(value, 'value.indicators.caution', null)}
                                            notice={_.get(value, 'value.indicators.notice', null)}
                                        />
                                    </div>
                                ),
                            },
                            {
                                accessor: 'signed',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.subjectOnRecord` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        <Entity
                                            entity={_.get(value, 'value', null)}
                                            type={_.get(value, 'value.type', null)}
                                            inactive={_.get(value, 'value.inactive', false)}
                                            rowInactive={_.get(value, 'original.inactive', false)}
                                            value={_.get(value, 'value.name', null)}
                                            entId={_.get(value, 'value.id', null)}
                                            risk={_.get(value, 'value.indicators.risk', null)}
                                            caution={_.get(value, 'value.indicators.caution', null)}
                                            notice={_.get(value, 'value.indicators.notice', null)}
                                        />
                                    </div>
                                ),
                            },
                            {
                                accessor: 'state',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.state` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        {_.get(value, 'value', '')}
                                    </div>
                                ),
                            },
                            {
                                accessor: 'entitled',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.eligibleSubject` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        <Entity
                                            entity={_.get(value, 'value', null)}
                                            type={_.get(value, 'value.type', null)}
                                            inactive={_.get(value, 'value.inactive', false)}
                                            rowInactive={_.get(value, 'original.inactive', false)}
                                            value={_.get(value, 'value.name', null)}
                                            entId={_.get(value, 'value.id', null)}
                                            risk={_.get(value, 'value.indicators.risk', null)}
                                            caution={_.get(value, 'value.indicators.caution', null)}
                                            notice={_.get(value, 'value.indicators.notice', null)}
                                        />
                                    </div>
                                ),
                            },
                            {
                                accessor: 'amount',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.executionAmount` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        <Money value={_.get(value, 'value', {})} showCurrency={false} />
                                    </div>
                                ),
                            },
                            {
                                accessor: 'amount.currency',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.currency` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        <Currency currency={value?.value} />
                                    </div>
                                ),
                                width: 75,
                            },
                            {
                                accessor: 'executor',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.executor` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        <Entity
                                            entity={_.get(value, 'value', null)}
                                            type={_.get(value, 'value.type', null)}
                                            inactive={_.get(value, 'value.inactive', false)}
                                            rowInactive={_.get(value, 'original.inactive', false)}
                                            value={_.get(value, 'value.name', null)}
                                            entId={_.get(value, 'value.id', null)}
                                            risk={_.get(value, 'value.indicators.risk', null)}
                                            caution={_.get(value, 'value.indicators.caution', null)}
                                            notice={_.get(value, 'value.indicators.notice', null)}
                                        />
                                    </div>
                                ),
                            },
                            {
                                accessor: 'startDate',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.dateFrom` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        <CustomDate
                                            date={_.get(value, 'value.value', null)}
                                            precision={_.get(value, 'value.precision', null)}
                                        />
                                    </div>
                                ),
                                sortable: true,
                                width: 100,
                            },
                            {
                                accessor: 'endDate',
                                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.dateTo` }),
                                Cell: (value) => (
                                    <div className={cx(_.get(value, 'original.inactive') && 'inactive')}>
                                        <CustomDate
                                            date={_.get(value, 'value.value', null)}
                                            precision={_.get(value, 'value.precision', null)}
                                        />
                                    </div>
                                ),
                                sortable: true,
                                width: 100,
                            },
                        ]}
                        settings={{
                            pagination,
                            sorted,
                            filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                                id: actFilter?.id,
                                value: actFilter?.value || [],
                            })),
                        }}
                        onTableChange={this.handleTableChange}
                        pageSizeOptions={[5, 10, 20, 50, 100]}
                        texts={{
                            pagination: {
                                page: intl.formatMessage({ id: 'global.page' }),
                                from: intl.formatMessage({ id: 'global.of' }),
                                rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                                rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                                all: intl.formatMessage({ id: 'global.all' }),
                            },
                            filter: {
                                valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                                fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                            },
                        }}
                    />
                </div>
            </div>
        )
    }
}
